import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';
import { hasValue } from '../../../../general/js/general-helpers';

export function getSSOItemListFormData(formDataUrl = '', formId = '') {
    let callBackUrl = hasValue(formDataUrl) ? formDataUrl : apiConstants.loadSSOItemListFormDataUrl;

    if(hasValue(formId)){
        callBackUrl = `${callBackUrl}?id=${formId}`;
    }

    return fetch(callBackUrl, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError);
}